import { Injectable } from "@angular/core";
import { AuthorizationService as AUTHORIZATION, FeUtil } from "../../../hezky-routes";
import { AccountDisableComponent } from "../../../shared/components/info-page/account-disable.component";

@Injectable({ providedIn: 'root' })
export class ExceptionHandlerService {
    private readonly displayStatusCodes = new Set([1004]);
    private logoutInProgress = false;

    constructor(private feUtil: FeUtil, private authorization: AUTHORIZATION) { }

    handleHttpError(error: { status: number, message: string, data?:any }, body?: any): void {
        if (!error) throw new Error('No error object provided');
        const { status, message, data } = error;
        switch (status) {
            case 0:
                // this.feUtil.message.error('Server is down or unreachable.');
                throw error;
            case 406:
                this.feUtil.message.error('Virus detected in uploaded file.');
                throw error;
            default:
                if (this.displayStatusCodes.has(status)) {
                    if (data?.allow_update || data?.system_generated_password) {
                        let { email, customer_id } = body;
                        this.feUtil.modalSvc.create<AccountDisableComponent>({
                            nzContent: AccountDisableComponent,
                            nzData: { data: { expiryDate: 45, loginData: { email, customer_id }, isSystem: data?.system_generated_password } },
                            nzWidth: '500px',
                            nzMaskClosable: false,
                            nzClosable: true,
                            nzCloseOnNavigation: true,
                            nzFooter: null
                        });
                    } else {
                        this.feUtil.message.error(message);
                    }
                    throw error;
                } else if (status !== 200) throw error;
                break;
        }
    }

    public handleAuthError(): void {
        if (!this.logoutInProgress) {
            this.logoutInProgress = true;
            this.authorization.onLogout(() => { this.logoutInProgress = false; });
        }
    }
}